import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { FiltersBarDropdownButton } from "app/components/filters-bar/filters-bar-dropdown/FiltersBarDropdownButton";
import { FILTER_CHANGED_NOTIFICATION_WIDTH } from "app/components/filters-bar/FiltersBase";
import FilterChangedNotification from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltip";
import { EFilterChangedTooltipTypes } from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltipTypes";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { getDropDownButtonTitle } from "app/components/duration-selector/DurationSelectorUtils";

const DurationSelectorTextStyle = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
`;

const DurationSelectorIconStyle = styled.div`
    width: 24px;
    height: 24px;
    margin-right: 8px;
`;

const DurationSelectorDropdownButton = styled(FiltersBarDropdownButton)`
    & .DropdownButton-text.DropdownButton-text {
        text-indent: 0;
        margin-right: 15px;
        width: 100%;
    }
`;

interface IDurationSelectorButtonProps {
    height?: string | number;
    isDisabled?: boolean;
    initialPreset: string;
    presets: { id?: string | number; text: string }[];
    isCompare?: boolean;
    presentNotificationIndicator?: boolean;
    presentCustomIndicator?: boolean;
    allowSingleDayPresentation?: boolean;
    presentNotificationTooltipKey?: string;
}

export const DurationSelectorButton = forwardRef<
    HTMLDivElement,
    IDurationSelectorButtonProps & HTMLAttributes<HTMLDivElement>
>(
    (
        {
            height,
            isDisabled = false,
            initialPreset,
            presets,
            isCompare: _isCompare = false,
            presentNotificationIndicator = false,
            presentCustomIndicator = true,
            allowSingleDayPresentation = false,
            presentNotificationTooltipKey = "common.filters.duration.tooltip.body",
            ...divAttr
        },
        ref,
    ) => {
        const translate = useTranslation();
        const body = translate(presentNotificationTooltipKey);
        return (
            <div
                ref={ref}
                {...divAttr}
            >
                <DurationSelectorDropdownButton
                    disabled={isDisabled}
                    hasValue={true}
                    height={height}
                >
                    <DurationSelectorIconStyle>
                        <SWReactIcons iconName="daily-ranking" />
                    </DurationSelectorIconStyle>
                    <DurationSelectorTextStyle>
                        {getDropDownButtonTitle(
                            initialPreset,
                            presets,
                            presentCustomIndicator,
                            allowSingleDayPresentation,
                        )}
                    </DurationSelectorTextStyle>
                    {presentNotificationIndicator ? (
                        <FilterChangedNotification
                            width={FILTER_CHANGED_NOTIFICATION_WIDTH}
                            tooltipBody={body}
                            filterType={EFilterChangedTooltipTypes.DATE_PICKER}
                        />
                    ) : null}
                </DurationSelectorDropdownButton>
            </div>
        );
    },
);
